import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ChatService } from '../../../core/services/chat.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import MetisMenu from 'metismenujs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  isCondensed: boolean = true;
  @ViewChild('componentRef') scrollRef;
  // @Input() isCondensed = false;
  @ViewChild('sideMenu') sideMenu: ElementRef;
  userInput: string = '';
  questions: any = [
    { question: 'How many sites are active for the customer currently' },
    { question: 'How many employees are subscribed in each site' },
    { question: 'How many new subscriptions have happened on a monthly basis for the past 3 months' },
    { question: 'How many vendors are we using at each site' },
    { question: 'How many vehicles has each vendor have' },
    { question: 'Which vehicles have expiring documentation this month' },
    { question: 'How many vehicles whose documents have expired are in the solution' },
    { question: 'How many drivers are active' },]
  messages: any = [];
  loading = false;
  dataFlag: boolean = false;
  allExpandState: any;
  @ViewChild('chatWindow') chatWindow!: ElementRef;
  awaitingExport: boolean;
  lastOutput: string;
  responseDataArray: any[] = [];
  request: any;
  data: any;
  _allChatHistory: any = [];
  chatId: any;
  empId: any = this.localStorage.getUserObject();
  @Output() mobileMenuButtonClicked = new EventEmitter();
  menu: any;
  liveData: any = [
    { question: 'Where is my Cab ?' },
    { question: 'What is my OTP ?' },
    { question: 'What is my Cab Number ?' },
    { question: 'What is my Pick-Up Time ?' },
    { question: 'What time will my cab reach me ?' },
    { question: 'What is my Pick-Up Time for tomorrow ?' },]

  menuItems = [
    {
      id: 1,
      label: 'New Chat',
      icon: 'bx-chat',
    },
    {
      id: 2,
      label: 'Chat History',
      icon: 'bx-history',
    },
    {
      id: 3,
      label: 'FAQs',
      icon: 'bx-message-alt-dots',
    },
    {
      id: 4,
      label: 'Live Data',
      icon: 'bx-reset',
    },
  ]
  liveDataResponse: any;
  liveDataFlag: boolean = false;

  constructor
    (
      private chatService: ChatService,
      private localStorage: ServiceLocalStorage,
      private notifyService: NotificationService,
      private ngxLoader: NgxUiLoaderService,
    ) { }

  ngOnInit(): void {
    this.getAllChatsBasedOnUser();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
  }

  sendMessage() {
    if (!this.userInput.trim()) return;
    const message = this.userInput;
    this.messages.push({ text: message, sender: 'user' });
    this.userInput = '';
    this.scrollToBottom();
    this.loading = true;
    if (message.includes("clear")) {
      this.clearChat();
      this.loading = false;
      return;
    }
    if (this.chatId) {
      const payload = {
        "emp_id": this.empId.userInfoDetails.employeeId,
        "chat_id": this.chatId,
        "query": message,
      }
      this.dynamicApi(payload);
    }
    else {
      let data =
      {
        "user_id": this.empId.userInfoDetails.employeeId,
        "query": message
      }
      this.request = this.chatService.startNewChat(data).subscribe((success) => {
        if (success) {
          this.chatId = success.chat_id;
          const payload = {
            "emp_id": this.empId.userInfoDetails.employeeId,
            "chat_id": this.chatId,
            "query": message,
          }
          setTimeout(() => {
            this.dynamicApi(payload);
          }, 1000)

        }
      }, (err) => console.error("Oops got into some issue, please try again...", err));
    }

  }

  dynamicApi(payload) {
    this.request = this.chatService.askDynamicQuestion(payload).subscribe(value => {
      let response = value.output;
      // if (response.raw_text.includes("Database error")) {
      //   this.messages.push({ text: "Oops got into some issue, please try again...", sender: 'ai' });
      //   this.loading = false;
      //   return;
      // }

      // If response is a table type
      // if (response.type === 'table' && response.columns && response.rows) {
      // Filter out separator rows (rows where first cell is dashes)
      this.dataFlag = true;
      this.awaitingExport = true;
      // const filteredRows = response.rows.filter(row => !/^[-\s]+$/.test(row[0]));

      // Push prefix message
      // if (response.prefix) {
      //   this.messages.push({ text: response.prefix, sender: 'ai', prefix: response.prefix, raw_text: response.raw_text });
      // }

      // Push table data message
      if (response.raw_text) {
        this.messages.push({
          sender: 'ai',
          chatId: value.chat_id,
          output: response,
          raw_text: response.raw_text,
          user_query_session_id: value.user_query_session,
          
        });
      }
      else {
        this.messages.push({
          sender: 'ai',
          chatId: value.chat_id,
          output: response,
          raw_text: response.raw_text,
          data_count: value.data_count,
          user_query_session_id: value.user_query_session
        });
      }
      // } else {
      // Fallback: plain text
      // this.messages.push({ text: response.raw_text || response.answer || '', sender: 'ai', prefix: response.prefix, raw_text: response.raw_text });
      // this.dataFlag = true;
      // }
      this.loading = false;
      this.scrollToBottom();
    },
      (err) => { this.notifyService.showError("Oops! I'm having trouble responding right now. Please try again in a moment", null) }
    );
  }

  scrollToBottom() {
    setTimeout(() => {
      this.chatWindow.nativeElement.scrollTop = this.chatWindow.nativeElement.scrollHeight;
    }, 10);
    this.ngxLoader.stop();
  }

  export(format, rdata) {
    let chat_id = rdata.chatId ? rdata.chatId : this.chatId;
    let d1 = {
      "output_format": "excel",
      "chat_id": chat_id,
      "user_id": this.empId.userInfoDetails.employeeId,
      "user_query_session": rdata.user_query_session_id ? rdata.user_query_session_id : rdata.session_id
    }
    this.chatService.exportFile(d1).subscribe(blob => {
      const fileName = `report.${format === 'pdf' ? 'pdf' : 'xlsx'}`;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      this.awaitingExport = false;
    },
      (err) => {
        this.notifyService.showError("Download failed", null);
        this.awaitingExport = false;
      });
  }

  clearChat() {
    this.messages = [];
    this.awaitingExport = false;
    this.loading = false;
    this.dataFlag = false;
    this.liveDataFlag = false;
    this.chatId = '';
    this.lastOutput = "";
    this.onStop();
  }

  onStop() {
    this.request.unsubscribe();
    this.loading = false;
  }

  hasItems(item) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  onClickQuestion(data) {
    if (this.liveDataFlag) {
      this.messages = [];
    }
    this.userInput = data.question;
    this.liveDataFlag = false;
  }

  getAllChatsBasedOnUser() {
    const payload = {
      user_id: this.empId.userInfoDetails.employeeId,
    }
    this.request = this.chatService.getAllUserChats(payload).subscribe(success => {
      if (success) {
        this._allChatHistory = success;
      }
      else {
        this._allChatHistory = [];
        this.notifyService.showInfo("No Chat History Found", null);
      }
    },
      (err) => this.notifyService.showError("Error in fetching the user chat history", null));
  }

  getChatHistory(chat) {
    this.ngxLoader.start();
    this.userInput = '';
    this.messages = [];
    this.dataFlag = true;
    this.liveDataFlag = false;
    this.chatId = chat.chat_id;
    const payload = {
      user_id: this.empId.userInfoDetails.employeeId,
      chat_id: chat.chat_id,
    }
    this.request = this.chatService.getChatHistory(payload).subscribe(response => {
      response.forEach(element => {
        if (element.human) {
          this.messages.push({ text: element.human, sender: 'user' });
        }
        else {
          // If response is a table type
          if (element.ai) {
            if (element.data_count > 0) {
              this.messages.push({
                sender: 'ai',
                output: element.ai,
                data_count: element.data_count,
                session_id: element.session_id
              });
            }
            else {
              this.messages.push({
                sender: 'ai',
                raw_text: element.ai,
                data_count: element.data_count,
                session_id: element.session_id
              });
            }
          }
        }
      });
      this.scrollToBottom();
    },
      (err) => this.notifyService.showError("Error in fetching the chat history", null));
  }

  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.onToggleMobileMenu();
  }

  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');
    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
    if (this.isCondensed == true) {
      this.ngOnChanges();
    }
  }

  onLiveDataClick(data) {
    if (this.liveDataFlag == false) {
      this.userInput = '';
      this.messages = [];
      this.dataFlag = true;
    }
    this.liveDataApi(data);
  }

  liveDataApi(data) {
    this.onStop();
    this.messages.push({ text: data.question, sender: 'user' });
    this.loading = true;
    this.liveDataFlag = true;
    let chatKey;
    if (data.question == 'What is my Cab Number ?') {
      chatKey = 'CD';
    }
    if (data.question == 'What time will my cab reach me ?') {
      chatKey = 'CL';
    }
    if (data.question == 'Where is my Cab ?') {
      chatKey = 'CL';
    }
    if (data.question == 'What is my OTP ?') {
      chatKey = 'CD';
    }
    if (data.question == 'What is my Pick-Up Time ?') {
      chatKey = 'CD';
    }
    if (data.question == 'What is my Pick-Up Time for tomorrow ?') {
      chatKey = 'CDT';
    }
    this.request = this.chatService.getLiveData(chatKey).subscribe(success => {
      if (success) {
        this.liveDataResponse = success.message;
        this.messages.push({ text: this.liveDataResponse, sender: 'ai', prefix: this.liveDataResponse, raw_text: this.liveDataResponse });
        if (success.driverLocation) {
          this.messages.push({ href: "https://www.google.com/maps/dir/?api=1&origin=" + success.driverLocation + " &destination=" + success.empLocation + "&travelmode=driving", sender: 'ai' });
        }
      }
      else {
        this.liveDataResponse = [];
        this.notifyService.showInfo("No Response", null);
      }
      this.loading = false;
    },
      (err) => this.notifyService.showError("Error in fetching the Live Data", null));
  }
  redirectionMap(link) {
    window.open(link); return false;
  }
}

